import React from "react";
import cx from "classnames";
import stylesV2 from "./Fieldset.module.scss";
import stylesV3 from "./FieldsetV2.module.scss";
import { useLocation } from "react-router-dom";
import { useSchedulingABVariant } from "features/scheduling/utils/useSchedulingABVariant";

interface FieldsetProps {
  alwaysVertical?: boolean;
  legend: string;
  aside?: string;
  legendClassName?: string;
  fieldGroupClassName?: string;
}

export const FieldsetNew: React.FC<FieldsetProps> = ({
  alwaysVertical,
  legend,
  aside,
  legendClassName,
  fieldGroupClassName,
  children,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;

  return (
    <fieldset className={styles.fieldset}>
      <legend
        className={cx(styles.legend, legendClassName, {
          [styles.alwaysVertical]: alwaysVertical,
        })}
      >
        {legend}
        {aside && (
          <>
            <br />
            <span className={cx(styles.aside)}>{aside}</span>
          </>
        )}
      </legend>

      <div className={cx(styles.fieldGroupCustom, fieldGroupClassName)}>
        {children}
      </div>
    </fieldset>
  );
};